import { Icons } from '@/components/icons';

interface LabelProps {
  pathname: string;
}

const Label: React.FC<LabelProps> = ({ pathname }: LabelProps) => {
  if (pathname === '/overview') {
    return <Icons.protocolLabel />;
  }

  if (pathname === '/swap') {
    return <Icons.swapLabel />;
  }

  if (pathname === '/faucet') {
    return <Icons.faucetLabel />;
  }

  if (pathname === '/liquidations') {
    return <Icons.liquidationsLabel />;
  }

  // if (pathname === '/governance') {
  //   return <Icons.governanceLabel />;
  // }

  if (pathname === '/quanta') {
    return <Icons.quantaLabel />;
  }

  if (pathname === '/quanta/missions') {
    return <Icons.missionsLabel />;
  }

  if (pathname === '/quanta/side-missions') {
    return <Icons.sideMissionsLabel />;
  }

  if (pathname === '/quanta/leaderboard') {
    return <Icons.leaderBoardLabel />;
  }

  return <Icons.vaultLabel />;
};

export default Label;
